import constants from '../../constants';
import { isSmartPhone } from '../../utilities/helper';
import View from '../view';
import './index.css';

interface Props {
  onClickYes: any;
  onClickNo: any;
}

const GameExitModal = ({ onClickYes, onClickNo }: Props) => {
  return (
    <View className={isSmartPhone ? 'gameExitModal__wrapper__mWeb' : 'gameExitModal__wrapper'}>
      <img
        className={isSmartPhone ? 'gameExitModal__warnImg__mWeb' : 'gameExitModal__warnImg__web'}
        src={constants.Images.warning}
      />
      <div className="gameExitModal__warnText">{`Are you sure you want to exit ?`}</div>

      <div className="gameExitModal__btns__wrapper">
        <button
          className={isSmartPhone ? 'gameExitModal__yesBtn__mWeb' : 'gameExitModal__yesBtn__web'}
          onClick={onClickYes}>
          Yes
        </button>
        <button
          className={isSmartPhone ? 'gameExitModal__noBtn__mWeb' : 'gameExitModal__noBtn__web'}
          onClick={onClickNo}>
          No
        </button>
      </div>
    </View>
  );
};

export default GameExitModal;
